// AuthRedirect.tsx
import React from "react";
import { useAuth0 } from './useAuth0';
import { useUser } from "./UserContext";
import { Navigate } from "react-router-dom";
import LoadInitialData from "./LoadInitialData";


const AuthRedirect: React.FC = () => {
    const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();
    const { user } = useUser();

    console.log("AuthRedirect: ", user);

    const handleAuthentication = async () => {
        if (!isLoading && !isAuthenticated) {
            console.log("hAuthRedirect.handleAuthentication");
            await loginWithRedirect({
                appState: { returnTo: window.location.pathname },
                authorizationParams: {
                    // Inclui o base path (/admin atrás do nginx; '' local) — senão o
                    // Auth0 volta pra raiz e o 302 → /admin perde o ?code&state (loop).
                    redirect_uri: window.location.origin + (process.env.PUBLIC_URL || ''),
                },
            });
        }
    };

    if (!isAuthenticated && !isLoading) {
        handleAuthentication();
    }

    // Verifica se há um erro durante a autenticação
    if (error) {
        return <div data-cy="auth-error-message">Erro ao tentar logar: {error.message}</div>;
    }

    // Agora verifica se o usuário foi autenticado e o `user` está definido
    if (isAuthenticated && user && !user?.id) {
        return (
        <>
            <LoadInitialData />
            <Navigate to="/home" />;
        </>)
    }

    return <div data-cy="auth-redirecting">Redirecting to login...</div>;
};

export default AuthRedirect;
